export enum LastpassLoginType {
  MasterPassword = 0,
  // Not sure what Types 1 and 2 are?
  Federated = 3,
}
